import Immutable from 'immutable';

export interface RawPhoto {
  projectid: string;
  fileid: string;
  filename: string;
  category: string;
  extension: string;
  filesize: number;
  uploadStatus: string;
  url: string;
}

const defaultValues: RawPhoto = {
  projectid: '',
  fileid: '',
  filename: '',
  category: '',
  extension: '',
  filesize: 0,
  uploadStatus: '',
  url: '',
};

export const PhotoFactory = Immutable.Record(defaultValues, 'Photo');

export class Photo extends PhotoFactory {
  static deserialize(rawPhoto: RawPhoto): Photo {
    return new Photo(rawPhoto);
  }

  serialize(): RawPhoto {
    return this.toJS();
  }
}

export type PhotoList = Immutable.List<Photo>;
